import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { fonts } from "../../../theme/theme";
import { CHART } from "./WheelOfLifeChartAlt.constants";

export const RootBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const HeaderBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: theme.spacing(2),
  },
}));

export const ChartBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: CHART.HEIGHT,
  marginTop: theme.spacing(-1),
}));

export const ScoreText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: fonts.gotham,
  width: "100%",
  textAlign: "right",
  marginBottom: "auto",
  marginLeft: "auto",
  marginTop: 5,
  [theme.breakpoints.down("sm")]: {
    textAlign: "left",
  },
}));
